const FINOPS_VIEWS = {
  'usage-roi': { id: 'finops-roi', title: 'Usage & ROI' },
  tokenomics: { id: 'finops', title: 'Tokenomics' },
  'cost-simulator': { id: 'finops-simulator', title: 'LLM Cost Simulator' },
  budgets: { id: 'finops-budget', title: 'Budget & Forecasting' },
  'cost-allocation': { id: 'finops-allocation', title: 'Cost Allocation' },
  greenops: { id: 'finops-greenops', title: 'GreenOps' },
  settings: { id: 'finops-settings', title: 'FinOps Settings' },
};

const LEGACY_PATH_VIEWS = [
  ['/finops/simulator', 'cost-simulator'],
  ['/finops/tokenomics', 'tokenomics'],
  ['/finops/roi', 'usage-roi'],
  ['/finops/budget', 'budgets'],
  ['/finops/allocation', 'cost-allocation'],
  ['/finops/greenops', 'greenops'],
  ['/finops/settings', 'settings'],
];

/**
 * Resolve the visible FinOps view after legacy routes are folded into the
 * query-driven Usage & ROI shell. The pathname alone is insufficient because
 * every consolidated page uses /finops/usage-roi and differs by ?tab=.
 */
export const resolveFinOpsView = (pathname = '', search = '') => {
  const isConsolidated = pathname.startsWith('/finops/usage-roi')
    || pathname.startsWith('/custom-agents/usage-roi');

  if (isConsolidated) {
    const requested = new URLSearchParams(search).get('tab') || 'usage-roi';
    const tab = requested === 'overview' ? 'usage-roi' : requested;
    const view = FINOPS_VIEWS[tab] || FINOPS_VIEWS['usage-roi'];
    return { tab, ...view };
  }

  const legacy = LEGACY_PATH_VIEWS.find(([prefix]) => pathname.startsWith(prefix));
  if (legacy) {
    const tab = legacy[1];
    return { tab, ...FINOPS_VIEWS[tab] };
  }

  if (pathname === '/finops' || pathname === '/finops/') {
    return { tab: 'tokenomics', ...FINOPS_VIEWS.tokenomics };
  }

  return null;
};

export default FINOPS_VIEWS;
